import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { Rtl2SsoService, UserProfile as Rtl2SsoUserProfile } from '@rtl2/sso';
import { routeNames } from '@shared/models';
import { UserProfile } from '@app/store/portal.actions';
import { PortalState } from '@app/store/portal.state';

@Component({
  selector: 'prp-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent {
  profile: Rtl2SsoUserProfile;
  profileLocal: Rtl2SsoUserProfile;
  roles: Observable<[]>;
  routeNames = routeNames;

  public previewProfile = false;

  @Select(PortalState.userprofile)
  userprofile$: Observable<any>;

  constructor(private store: Store, private ssoService: Rtl2SsoService) {
    ssoService.getUserProfile().subscribe((data) => (this.profile = data));
    this.profileLocal = ssoService.getUserProfileFromLocalStorage();
    this.roles = ssoService.hasUserAppRoles$.pipe(
      map((v) => (v ? ssoService.getUserRoles() : null))
    );
  }

  onClick(navigate: string) {
    this.store.dispatch(new UserProfile());
    this.store.dispatch(new Navigate([routeNames.portalBase, navigate]));
  }

  toggleMenu() {
    this.store.dispatch(new UserProfile());
  }
}
